"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _OwnerRecord = _interopRequireDefault(require("customer-data-objects/owners/OwnerRecord"));

var OwnerWithRolesRecord = (0, _immutable.Record)((0, _extends2.default)({}, (0, _OwnerRecord.default)().toJS(), {
  userId: null,
  roles: (0, _immutable.Set)(),
  isActive: false
}), 'OwnerWithRoles');
var _default = OwnerWithRolesRecord;
exports.default = _default;
module.exports = exports.default;